import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import work from './work';
import theme from './theme';

const appReducer = combineReducers({
  work,
  theme,
  router: routerReducer,
});

const rootReducer = (state, action) => {
  let newState = state;
  return appReducer(newState, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js